export enum ODD {
  No_ODD = '0',
  NO_POVERTY = '1',
  ZERO_HUNGER = '2',
  GOOD_HEALTH_WELL_BEING = '3',
  QUALITY_EDUCATION = '4',
  GENDER_EQUALITY = '5',
  CLEAN_WATER_SANITATION = '6',
  AFFORDABLE_CLEAN_ENERGY = '7',
  DECENT_WORK_ECONOMIC_GROWTH = '8',
  INDUSTRY_INNOVATION_INFRASTRUCTURE = '9',
  REDUCED_INEQUALITIES = '10',
  SUSTAINABLE_CITIES_COMMUNITIES = '11',
  RESPONSIBLE_CONSUMPTION_PRODUCTION = '12',
  CLIMATE_ACTION = '13',
  LIFE_BELOW_WATER = '14',
  LIFE_ON_LAND = '15',
  PEACE_JUSTICE_STRONG_INSTITUTIONS = '16',
  PARTNERSHIPS_FOR_GOALS = '17',
}
